import { BackendModel } from "../../core/backend.service";

export class RespuestaPlataforma extends BackendModel {

    aprobado:boolean;
    mensaje:string;
  
  }


// WEBPACK FOOTER //
// ./src/app/pedido/models/respuesta-plataforma.ts